module.exports = __webpack_public_path__ + "img/parma-logo-icon.740b93c3.png";